var exports = {
  "h": "DiscoveryGuildPreviewModal.module__description___d0FZaU",
};

module.exports = exports;
